import {
  Container,
  Heading,
  htmlButton,
  useNotifier,
  useTranslateError,
  useBackend,
} from "lcm-iot-commons";
import { useIntl } from "react-intl";
import SignUpBreadcrumb from "./SignUpBreadcrumb";
import SignUpStepExplanation from "./SignUpStepExplanation";
import { useSignUp } from "../../context/SignUpContext";

export default function SignUpIdentification() {
  const backend = useBackend();
  const notifier = useNotifier();
  const intl = useIntl();
  const signUp = useSignUp();
  const translateError = useTranslateError();

  // Use the mutation pattern for resending confirmation
  const { mutateAsync: resendConfirmationEmail } = backend.post.useMutation(
    "/users/resend_confirmation",
  );

  const resendConfirmation = async (email: string) => {
    try {
      await resendConfirmationEmail({ email });
      notifier.showSuccess(
        intl.formatMessage({
          id: "signup.identification.resend_email.success",
        }),
      );
    } catch (error) {
      notifier.showError(translateError(error));
    }
  };

  const step2Explanation = (
    <div id="identification-email-resend-description">
      <span>
        {intl.formatMessage({
          id: "signup.identification.step_2.description_1",
        })}
      </span>
      <div />
      <span id="identification-resend-message">
        {intl.formatMessage(
          { id: "signup.identification.step_2.description_2" },
          {
            button: htmlButton(
              () => resendConfirmation(signUp.signUpDetails.email || ""),
              {
                className: "btn-link btn-primary step-explanation-text-button",
              },
            ),
          },
        )}
      </span>
    </div>
  );

  return (
    <Container>
      <SignUpBreadcrumb current="identification" action="signup" />
      <Heading
        id="sign-up-identification-header"
        title={intl.formatMessage({ id: "signup.identification.header" })}
      />
      <p className="space-after">
        {intl.formatMessage({ id: "signup.identification.message" })}
      </p>
      <div className="step-explanation">
        <SignUpStepExplanation
          text={intl.formatMessage({ id: "signup.identification.step_1.text" })}
          description={intl.formatMessage({
            id: "signup.identification.step_1.description",
          })}
          step="1"
        />
        <SignUpStepExplanation
          text={intl.formatMessage({ id: "signup.identification.step_2.text" })}
          description={step2Explanation}
          step="2"
        />
        <SignUpStepExplanation
          text={intl.formatMessage({ id: "signup.identification.step_3.text" })}
          description={intl.formatMessage({
            id: "signup.identification.step_3.description",
          })}
          step="3"
        />
      </div>
    </Container>
  );
}
